import { HTMLAttributes, useEffect, useState } from 'react';

import { Box } from '@mui/material';

import { FontSettings, useMergedRef, useTextWidth } from '@cast/utils';

import { SxProps, WithRef } from '../../types';

type Props = HTMLAttributes<HTMLInputElement> & {
  fontSettings?: FontSettings;
  value?: string;
  onWidthChanged?: (width: number) => void;
  setProps?: string | string[];
  styleFactory?: (width: number, text: string) => SxProps;
  placeholder?: string;
};

const AutoSizingInput = ({
  ref,
  fontSettings,
  onWidthChanged,
  styleFactory = (width) => ({ width }),
  ...props
}: WithRef<HTMLInputElement, Props>) => {
  const [innerRef, setInnerRef] = useMergedRef(ref);
  const [innerVal, setInnerVal] = useState<string>('');
  const isControlled = props.value !== undefined;
  const width = useTextWidth(
    !isControlled ? innerVal : props.value || props.placeholder,
    innerRef?.current ?? undefined,
    fontSettings
  );
  useEffect(() => {
    if (width !== undefined) {
      onWidthChanged?.(width);
    }
  }, [width, onWidthChanged]);
  return (
    <Box
      component="input"
      {...props}
      onChange={(event) => {
        setInnerVal(event.target.value);
        props.onChange?.(event);
      }}
      ref={setInnerRef}
      sx={styleFactory?.(width || 0, props.value || '')}
    />
  );
};
AutoSizingInput.displayName = 'AutoSizingInput';

export default AutoSizingInput;
